import React from "react";
import "./hero.scss";
import Div from "../Div";
import { Box, Typography, Button, Grid, Link } from "@mui/material";

export default function Hero({
  image,
  title,
  subtitle,
  btnText,
  btnLink,
  scrollDownId,
  socialLinksHeading,
  heroSocialLinks,
  bgImageUrl,
}) {
  const handleDonatePageRedirection = () => {
    window.open("https://rzp.io/rzp/LdYyeP5n", "_blank");
  };

  const handleRedirect = () => {
    window.open("https://rzp.io/rzp/EVNrnZ7q", "_blank");
  };

  const handleRedirectionToTechMeet = () => {
    window.open("https://tech-meet.betca.org", "_blank");
  };

  return (
    <Div
      className="cs-hero cs-style1 cs-bg cs-fixed_bg cs-shape_wrap_1"
      style={{
        backgroundColor: "#add5fc",
        backgroundImage: "linear-gradient(180deg, #add5fc 0%, #eaf9f9 100%)",
      }}
      // style={{ backgroundImage: `url(${bgImageUrl})` }}
    >
      <Div className="cs-shape_1" />
      <Div className="cs-shape_1" />
      <Div className="cs-shape_1" />
      <Div className="container">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          rowGap={2}
          sx={{ mt: -8 }}
        >
          <img src={image} alt="Logo.png" width={600} />
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            rowSpacing={2}
            columnSpacing={1}
            sx={{ textAlign: "center" }}
          >
            {/* <Grid item xs={11} md={11} sm={11} lg={6}>
              <Typography variant="h5" color="black" sx={{ fontWeight: 600 }}>
                {parse(title)}
              </Typography>
              <Button
                size="medium"
                onClick={handleRedirect}
                variant="contained"
                color="primary"
                sx={{ borderRadius: "12px" }}
              >
                Register Now
              </Button>
            </Grid> */}
            <Grid item xs={11}>
              <Typography variant="h5" color="black" sx={{ fontWeight: 600 }}>
                Be a Patron of BeTCA
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Button
                size="large"
                LinkComponent={Link}
                href="https://docs.google.com/forms/d/e/1FAIpQLScwHJd0MKUYhJVZrYCdF7SS7JGfx2vHoXgMeaFadta22GGVNA/viewform"
                target="_blank"
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: "12px",
                  "&:hover": {
                    color: "#ffff",
                  },
                }}
              >
                Express your Interest
              </Button>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Button
                size="large"
                onClick={handleRedirect}
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: "12px",
                }}
              >
                Annual Support
              </Button>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Button
                size="large"
                onClick={handleDonatePageRedirection}
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: "12px",
                }}
              >
                Donate Now
              </Button>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Button
                size="large"
                onClick={handleRedirectionToTechMeet}
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: "12px",
                }}
              >
                Register for Tech Meet 2026
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Div>
      {/* <Div className="cs-hero_info">
            <Div>
              <Button btnLink={btnLink} btnText={btnText} />
            </Div>
            <Div>
              <Div className="cs-hero_subtitle">{subtitle}</Div>
            </Div>
          </Div>
        </Div>*/}
      {/* <VerticalLinks data={heroSocialLinks} title={socialLinksHeading} />  */}
      <a href={scrollDownId} className="cs-down_btn">
        .
      </a>
    </Div>
  );
}
